export function getRandomItem(array: any[]) {
    return array[Math.floor(Math.random() * array.length)];
}

export function getLastItem(array: any[]) {
    if (array.length) return array[array.length - 1];

    return null;
}

export function getUniqueItems(array: any[], condition: (item: any, index: number, self: any[]) => boolean) {
    const dublicated: any[] = [];

    const uniqueItems = array.filter((item, index, self) => {
        const result = condition(item, index, self);
        if (condition(item, index, self)) {
            dublicated.push(item);
        }

        return result;
    });

    return {
        uniqueItems,
        dublicated,
    };
}